const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const auth = state => state.user


export {
  config,
  palette,
  isLoading
}
